export default __webpack_public_path__ + "static/media/sports09.a54214e1.png";